import { SVGIcon } from '@superops/super-icons';
import { TextStyle } from '@superops/ui-design-system';
import React from 'react';

interface GroupSummaries {
  name: string;
  summary: string;
}

interface SummaryCardProps {
  summary: string;
  groupSummaries?: GroupSummaries[];
}

const SummaryCard: React.FC<SummaryCardProps> = ({
  summary,
  groupSummaries
}) => {
  return (
    <div className="p10 br10 ai-dark-bg">
      <div className="flex g10 actr">
        <div className="flex">
          <SVGIcon name="AIWand" />
        </div>
        <div>
          <TextStyle>Similar ticket summary</TextStyle>
        </div>
      </div>

      <div className="mt10">
        <TextStyle>{summary}</TextStyle>
      </div>

      {groupSummaries && (
        <div className="flex col g10 mt20">
          {groupSummaries.map((groupSummary, index) => {
            const { name, summary: groupSummaryContent } = groupSummary;
            const sNo = index + 1;

            const title = `${sNo}. ${name}`;
            return (
              <div id="group-summary-item">
                <div id="group-summary-title" className="mb-5">
                  <TextStyle>{title}</TextStyle>
                </div>

                <div id="summary-content">
                  <TextStyle>{groupSummaryContent}</TextStyle>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SummaryCard;
